import styled from 'styled-components';

import { Text } from '../../../../ToolkitV2/Text/Text';
import { donedealBreakpoints } from 'styled-system';

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export const Title = styled(Text).attrs({
  forwardedAs: 'h2',
  size: 'L18',
  weight: 'bold',
  color: 'GREY_DARKER',
})`
  display: block;
`;

export const StepCounter = styled(Text).attrs({
  size: 'M14',
  color: 'GREY_DARK',
})`
  ${donedealBreakpoints.media.medium} {
    display: block;
    white-space: nowrap;
    flex-shrink: 0;
    margin-left: ${({ theme }) => theme.spacing.M16};
  }
`;
